import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import { useParams, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toastAlert } from "../../lib/toastAlert";
import config from "../../lib/config"
import isEmpty from "../../lib/isEmpty"
import uploadimg from "../../assets/images/uploadimg.png"
import { HideShowShowStatus, getcategorydata, updatecategory } from '../../actions/users';
import { Navigate, useNavigate } from 'react-router-dom';

const initialFormValue = {
    name: "",
    email: "",
    phonenumber: "",
    address1: "",
    address2: "",
    pincode: "",
    city: "",
    country: "",
    Photofile: "",
    BulkStatus: "false",
    BulkSubCategory: [],
    SubCategory: "",
    CollectionSeche: "SBT",
};

const EditCategory = () => {

    const navigate = useNavigate()
    const [formValue, setFormValue] = useState(initialFormValue);
    const [validateError, setValidateError] = useState({});
    const [catdata, setcatdata] = useState("");
    const [BulkStatusVAl, SetBulkStatus] = useState("false");
    const [categoryurl, setImage] = useState(uploadimg);

    const { userId } = useParams();
    
    const getCategoryData = async () => {
        var test = await getcategorydata(userId, "SBT");
        if (test.Success) {
          setcatdata(test.userValue.name)
          setImage(`${config.Back_Url}/admin/category/${test.userValue._id}/${test.userValue.image}`)
          SetBulkStatus(test.userValue.BulkStatus)
          setFormValue(test.userValue)
        }
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        var name = catdata;
        var coool = "SBT"
        let reqData = {
          name,
          Photofile,
          userId,
          BulkSubCategory,
          SubCategory,
          Collection: "SBT"
        };
        if (SubCategory == undefined || SubCategory == "") {
          toastAlert("error", "Enter SubCategory")
        } else {
          const { error } = await updatecategory(reqData);
          if (isEmpty(error)) {
            toastAlert("success", "Category details updated successfully");
            setTimeout(
              () => (window.location.href = "/categorylistSBT"),
              1000
            );
          } else {
            setValidateError(error);
          }
    
        }
    };

    const ShowHideSubCat = async (SubCat, CatName) => {
        var sendData = {
          name: CatName,
          SubcatStatus: SubCat.show == "true" || SubCat.show == true ? false : true,
          SubCatName: SubCat.name,
          Collection: "SBT"
        }
        var data = await HideShowShowStatus(sendData)
        if (data.Success) {
          toastAlert("success", "Status updated successfully")
        } else {
          toastAlert("error", "Failed to change Status.Try it again later")
        }
        getCategoryData()
    }

    const handleFile = (e) => {
        e.preventDefault();
        const { id, files } = e.target;
        let formData = { ...formValue, ...{ [id]: files[0] } }
        setFormValue(formData)
        var validExtensions = ["png", 'gif', 'webp', 'PNG', 'jpg', 'jpeg', 'GIF', 'JPEG', 'JPG']; //array of valid extensions
        if (e.target && e.target.files) {
          var reader = new FileReader()
          var file = e.target.files[0];
          var fileName = file.name;
          var fileNameExt = fileName.substr(fileName.lastIndexOf('.') + 1);
          if (!validExtensions.includes(String(fileNameExt))) {
            toastAlert("error", "Only these file types are accepted : " + validExtensions.join(', '));
            return false;
          }
          const fileSize = file.size;
          if (15000000 < fileSize) {
            toastAlert("error", "File size exceeds 15 MB");
            return false;
          }
          else {
            var url = reader.readAsDataURL(file);
            reader.onloadend = function (e) {
              if (reader.result) {
                setImage(reader.result);
              }
            }.bind(this);
          }
        }
    };

    const onChange = (e) => {
        e.preventDefault();
        const { id, value } = e.target;
        let formData = { ...formValue, ...{ [id]: value } };
        setFormValue(formData);
      };

    useEffect(() => {
        getCategoryData();
    }, []);

    const { name, Photofile, BulkStatus, BulkSubCategory, SubCategory, CollectionSeche } = formValue;

    return (
        <>
            <Container fluid className="common_bg position-relative">
                <div className="liner"></div>
                <Row>
                    <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                        <Sidebar />
                    </Col>
                    <Col xl={10} lg={12}>
                        <Header title={'Update Category'} />
                        <div className='common_page_scroller mt-5 pe-2'>
                        <div>
                              <button className='btn addcate' onClick={()=>navigate(-1)}>Back</button>
                            </div>
                            <form noValidate onSubmit={handleFormSubmit}>
                            <div className="categorylisdt">
                            <div className='row'>
                            <div className='col-xl-5 mt-4'>
                                        <label htmlFor="categoryName">Category Name</label>
                                        <input
                                            type="text"
                                            className='form-control'
                                            id="categoryName"
                                            value={catdata}
                                            disabled
                                            fullWidth
                                        />
                                        {validateError.name && (
                                            <span className="text-danger">{validateError.name}</span>
                                        )}
                                    </div>
                                    <div className='col-xl-5 mt-4'>
                                        <label htmlFor="Photofile" className='mb-2'>Choose Image</label>
                                        <input
                                            type="file"
                                            className='form-control'
                                            id="Photofile"
                                            onChange={handleFile}
                                            fullWidth
                                        />
                                        <label className='mt-2 mb-2'>Image Preview</label> <br></br>
                                        <img src={categoryurl} alt="category image" style={{ maxHeight: 100, maxWidth: 100 }} />
                                    </div>
                                    <div className='col-xl-5 mt-4'>
                                        <label htmlFor="SubCategory">Sub Category Name</label>
                                        <input
                                            type="text"
                                            className='form-control'
                                            id="SubCategory"
                                            value={SubCategory}
                                            onChange={onChange}
                                            fullWidth
                                        />
                                        {validateError.SubCategory && (
                                            <span className="text-danger">{validateError.SubCategory}</span>
                                        )}
                                    </div>
                                    {formValue.BulkSubCategory.length > 0 && (
                                        formValue.BulkSubCategory.map((item) => (
                                            <div className='col-xl-5 mt-4' key={item.name}>
                                                <input
                                                    type="text"
                                                    className='form-control'
                                                    id="Photofile"
                                                    value={item.name}
                                                    disabled
                                                    fullWidth
                                                />
                                                {validateError.name && (
                                                    <span className="text-danger">{validateError.name}</span>
                                                )}
                                                <button
                                                className='btn addcate px-2 py-2 mt-2'
                                                    type="button"
                                                    onClick={() => ShowHideSubCat(item, catdata)}
                                                >
                                                    {item.show === false || item.show === "false" ? "Show" : "Hide"}
                                                </button>
                                            </div>
                                        ))
                                    )}
                                </div>
                                <div>
                                    <button className='btn addcate mt-4' type="submit">Update</button>
                                </div>
                                </div>
                            </form>

                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default EditCategory